export const COOKIE_CONSENT_ACCEPTED = 'cookieconsent_accepted';
export const ACCOUNT_EVER_LOGGED = '_ak.io-al';

export function getCookie(cname) {
  var name = cname + '=';
  var decodedCookie = decodeURIComponent(document.cookie);
  var ca = decodedCookie.split(';');
  for (var i = 0; i < ca.length; i++) {
    var c = ca[i];
    while (c.charAt(0) === ' ') {
      c = c.substring(1);
    }
    if (c.indexOf(name) === 0) {
      return c.substring(name.length, c.length);
    }
  }
  return '';
}

export function setCookie(cname, cvalue, exdays) {
  let expires = '';
  if (!cvalue) {
    expires = 'Thu, 01 Jan 1970 00:00:00 UTC';
  } else {
    if (exdays) {
      const d = new Date();
      d.setTime(d.getTime() + exdays * 24 * 60 * 60 * 1000);
      expires = `expires=${d.toUTCString()};`;
    }
  }
  document.cookie = cname + '=' + cvalue + ';' + expires + 'path=/';
}
